import { useEffect } from 'react';
import AnalyticsHero from './components/AnalyticsHero';
import AnalyticsWhatIs from './components/AnalyticsWhatIs';
import AnalyticsReasons from './components/AnalyticsReasons';
import AnalyticsParameters from './components/AnalyticsParameters';
import AnalyticsStrategy from './components/AnalyticsStrategy';
import AnalyticsStages from './components/AnalyticsStages';
import AnalyticsLeadForm from './components/AnalyticsLeadForm';
import Footer from '../landing-page/components/Footer';
import { useSEO, getWebPageSchema, getOrganizationSchema } from '../../utils/seo';

export default function AnalyticsPage() {
  useSEO({
    title: 'Настройка сквозной аналитики «под ключ» Москва | От клика до кассы',
    description: 'Сквозная аналитика для бизнеса: узнайте, какой рекламный рубль приносит прибыль. Интеграция с CRM, коллтрекинг, дашборды. Индивидуальные решения для вашего бизнеса в Москве.',
    keywords: 'сквозная аналитика, настройка аналитики, коллтрекинг, CRM интеграция, маркетинговая аналитика',
    canonical: '/analytics',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        getOrganizationSchema(),
        getWebPageSchema(
          'Настройка сквозной аналитики «под ключ»',
          'Сквозная аналитика для бизнеса: узнайте, какой рекламный рубль приносит прибыль.',
          'SITE_URL/analytics'
        ),
      ]
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <AnalyticsHero />
      <AnalyticsWhatIs />
      <AnalyticsReasons />
      <AnalyticsParameters />
      <AnalyticsStrategy />
      <AnalyticsStages />
      <AnalyticsLeadForm />
      <Footer />
    </div>
  );
}
